import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';

import {ComponentsModule} from '../shared/components/components.module';
import {PipesModule} from "../shared/pipes/pipes.module";

import {SaseungRoutingModule} from './saseung-routing.module';

import {SaseungComponent} from './saseung.component';
import {SaseungDetailComponent} from './saseung-detail/saseung-detail.component';
import {SaseungHelpBtnComponent} from "./help/saseung-help-btn";
import {SaseungHelpPopupComponent} from "./help/saseung-help-popup.component";
import { SaseungItemComponent } from './saseung-item/saseung-item.component';


@NgModule({
  declarations: [
    SaseungComponent,
    SaseungDetailComponent,
    SaseungHelpBtnComponent,
    SaseungHelpPopupComponent,
    SaseungItemComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ComponentsModule,
    PipesModule,
    SaseungRoutingModule,
  ],
  exports: [
    SaseungDetailComponent,
    SaseungHelpBtnComponent,
    SaseungHelpPopupComponent,
    SaseungItemComponent,
  ]
})
export class SaseungModule {
}
